// @flow
import * as React from "react";

const List = (props) => {
  return <div className="view">edit</div>;
};

export default List;
